<template>
    <div class="content_btn_add_to_cart" :data-indicador="indicador">
        <div class="buttons_shop_contact">
            <button v-if="product.price_type == 'fixed' && product.sell_status == 'available'" :class="['btn_add_to_cart', !show_btn_ws ? 'full_width' : '']"
                @click="() => { return false; }">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="9" cy="21" r="1"></circle>
                    <circle cx="20" cy="21" r="1"></circle>
                    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                </svg>
                {{ lang.bsbtn_add_to_cart }}
            </button>
            <button
                v-else-if="product.price_type == 'contact' || product.price_type == 'variable' || product.sell_status != 'available'"
                :class="['btn_contact', !show_btn_ws ? 'full_width' : '']" @click="() => { return false; }">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="22" y1="2" x2="11" y2="13"></line>
                    <polygon points="22 2 15 22 11 13 2 9"></polygon>
                </svg>
                {{ contact_btn_text }}
            </button>
            <button class="btn-bStore_ws" v-if="show_btn_ws" @click="() => { return false; }">
                <i class="fab fa-whatsapp"></i>
            </button>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    props: ['indicador', 'product'],
    data() {
        return {
            contact_btn_text: 'Contact',
            show_btn_ws: false,
            lang: {
                bsbtn_add_to_cart: '',
            },
        };
    },
    computed: {
        ...mapGetters("ModApps/Marketea/", {
            get_currency: "get_bStore_currency",
            get_info: "get_bStore_info",
            langGetter: "lang",
        }),
        precio_final: function() {
            if(this.product.discount_active && this.product.discount_percent > 0){
                return (this.product.price - ((this.product.discount_percent * this.product.price) / 100));
            }
            return this.product.price;
        }
    },
    watch: {
        langGetter() { this.lang = this.$store.getters['ModApps/Marketea/lang']; },
        get_currency(){
            this.currency = this.get_currency;
            // console.log('watch currency', this.currency)
        },
        get_info: {
            handler(newVal){
                let t = this;
                // console.log('get_info', newVal);
                t.contact_btn_text = (newVal && newVal.contact_btn_text) ? newVal.contact_btn_text : 'Contact';
                t.show_btn_ws = !!(newVal && Number(newVal.show_btn_ws) > 0);
            },
            deep: true,
            immediate: true,
        },
    },
    created() {
        let t = this;
        t.lang = t.$store.getters['ModApps/Marketea/lang'];
    },
};
</script>